import { useQuery } from '@tanstack/react-query';
import { preferencesKeys } from '../query-keys';
import { getPreference } from '../requests';
import type { GetPreferenceResponse } from '../types';

export type UsePreferenceQueryOptions = {
  enabled?: boolean;
};

export const usePreferenceQuery = <T extends Record<string, unknown>>(
  boardId: number | undefined,
  key: string,
  options?: UsePreferenceQueryOptions,
) =>
  useQuery<GetPreferenceResponse<T>>({
    queryKey: preferencesKeys.key(boardId ?? 0, key),
    queryFn: () => getPreference<T>({ boardId: boardId as number, key }),
    enabled: Boolean(boardId) && (options?.enabled ?? true),
    staleTime: Number.POSITIVE_INFINITY,
  });
